import Axios from "axios";
var ServiceService = (function () {
    function ServiceService() {
    }
    ServiceService.prototype.getServiceList = function (params) {
        return Axios.get("supplierclientapi/service/list", { params: params });
    };
    ServiceService.prototype.trialService = function (params) {
        return Axios.get("supplierclientapi/service/trial", { params: params });
    };
    ServiceService.prototype.payOpenService = function (params) {
        return Axios.post("supplierclientapi/service/open", params);
    };
    ServiceService.prototype.payRenewService = function (params) {
        return Axios.post("supplierclientapi/service/renew", params);
    };
    ServiceService.prototype.getPayFlag = function (params) {
        return Axios.get("supplierclientapi/service/query", { params: params });
    };
    ServiceService.prototype.getServiceDetail = function (params) {
        return Axios.get("supplierclientapi/service/detail", { params: params });
    };
    ServiceService.prototype.getServiceWarning = function () {
        return Axios.get("supplierclientapi/service/warning");
    };
    ServiceService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return ServiceService;
}());
export default ServiceService;
